var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.links)?_c('nav',{class:_vm.getClass},_vm._l((_vm.links),function(link,index){return _c('CommonLink',{key:_vm.getKey('CommonLinks__link', index),staticClass:"common-links__link",attrs:{"link":link}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }